import { unref } from 'vue';

/**
 *
 * @param {ColorId[]} selectedColorIds
 * @param {string} productId
 * @param {{[key: string]: {[key: string | number]: number}}} upcParserData
 * @param {number | null} selectedTypeId
 * @param {import('vue').ComputedRef<Product>} product
 */

export const getItemsArray = (
  product,
  selectedColorIds,
  productId,
  upcParserData,
  selectedTypeId = null,
) => selectedColorIds.map((color) => {
  const keyToUpc = [color, selectedTypeId]
    .filter((trait) => typeof trait === 'number' || typeof trait === 'string')
    .join('_');

  const upcId = upcParserData[keyToUpc];

  return {
    productId,
    upcId,
    upcNumber: unref(product).relationships.upcs[upcId].identifier.upcNumber,
  };
});

export default { getItemsArray };
